import React, {memo} from "react"
import {SettingsPageContainer} from "../../../../components/Settings/SettingsPageContainer"
import {PasswordContainer} from "../../../../components/PasswordContainer"
import {useOrientation} from "../../../../hooks/orientation"
import {useLocalization} from "../../../../hooks/localization"
import {SubMenuComponent} from "../../../../components/SubMenu"
import {Container} from "../../../../components/Container"
import iconCustomization from "../../../../assets/images/icons/settings/customization.png"
import iconScreen from "../../../../assets/images/icons/screen-menu.png"
import iconTheme from "../../../../assets/images/icons/theme.png"
import {useBackground} from "../../../../hooks/background-class"
import "./index.scss"

const P1 = "/settings/custom-menu/customization"
const P2 = "/settings/custom-menu/icon-theme"
const P3 = "/settings/custom-menu/screen-set"
export const CustomMenu = memo(function CustomMenu() {
    const {t} = useLocalization()
    const orientation = useOrientation()
    const [, , backgroundStyle] = useBackground()

    return (
        <PasswordContainer requiredRole="default" isFullscreen={true}>
            <SettingsPageContainer
                buttons={[]}
                backUrl={"/settings"}
                className={"background-settings"}
                style={backgroundStyle}
            >
                <Container className="no-sidebar">
                    <div className={"settings-page content-page " + orientation}>
                        <div className={"content-divider wrap admin"} style={{marginTop: "5px"}}>
                            <SubMenuComponent icon={iconCustomization} name={'Duvar Kağıdı'} path={P1} />
                            <SubMenuComponent icon={iconScreen} name={t("screen")} path={P3} />
                        </div>
                    </div>
                </Container>
            </SettingsPageContainer>
        </PasswordContainer>
    )
})
